import { render, staticRenderFns } from "./recommendation-items.vue?vue&type=template&id=2532591a&scoped=true"
import script from "./recommendation-items.vue?vue&type=script&lang=js"
export * from "./recommendation-items.vue?vue&type=script&lang=js"
import style0 from "./recommendation-items.vue?vue&type=style&index=0&id=2532591a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2532591a",
  null
  
)

export default component.exports